export const setStatusValve = (status: string): boolean => {
    const partes = status.split("/");
    return partes.includes("OPERABLE") || partes.includes("SELLA");
};
